(function () {
  'use strict';

  /* ---------- Announcement bar ---------- */
  function initAnnouncementBar() {
    var bar = document.querySelector('[data-announcement-bar]');
    if (!bar) return;
    var textEl = bar.querySelector('[data-announcement-text]');
    var messages = JSON.parse(bar.getAttribute('data-messages') || '[]');
    if (!messages.length) return;
    var i = 0;
    setInterval(function () {
      i = (i + 1) % messages.length;
      textEl.textContent = messages[i];
    }, 5000);
  }

  /* ---------- Header: scroll state, mega menu, flyouts ---------- */
  function initHeader() {
    var header = document.querySelector('[data-site-header]');
    if (!header) return;
    var isTransparent = header.getAttribute('data-transparent') === 'true';
    var megaMenus = header.querySelectorAll('[data-mega-menu]');
    var navItems = header.querySelectorAll('[data-nav-item]');
    var searchToggle = header.querySelector('[data-search-toggle]');
    var accountToggle = header.querySelector('[data-account-toggle]');
    var searchFlyout = header.querySelector('[data-search-flyout]');
    var accountFlyout = header.querySelector('[data-account-flyout]');

    function updateHeaderState() {
      if (!isTransparent) return;
      var scrolled = window.scrollY > 80;
      var menuOpen = header.querySelector('[data-mega-menu]:not([hidden])');
      var active = scrolled || !!menuOpen;
      header.classList.toggle('is-solid', active);
      header.classList.toggle('is-transparent', !active);
    }

    function closeAllMenus() {
      megaMenus.forEach(function (m) { m.hidden = true; });
      if (searchFlyout) searchFlyout.hidden = true;
      if (accountFlyout) accountFlyout.hidden = true;
      updateHeaderState();
    }

    navItems.forEach(function (item) {
      var key = item.getAttribute('data-nav-item');
      if (!key) return;
      item.addEventListener('mouseenter', function () {
        if (searchFlyout) searchFlyout.hidden = true;
        if (accountFlyout) accountFlyout.hidden = true;
        megaMenus.forEach(function (m) {
          m.hidden = m.getAttribute('data-mega-menu') !== key;
        });
        updateHeaderState();
      });
    });

    header.addEventListener('mouseleave', closeAllMenus);

    if (searchToggle && searchFlyout) {
      searchToggle.addEventListener('click', function () {
        var willOpen = searchFlyout.hidden;
        megaMenus.forEach(function (m) { m.hidden = true; });
        if (accountFlyout) accountFlyout.hidden = true;
        searchFlyout.hidden = !willOpen;
        updateHeaderState();
        if (willOpen) {
          var input = searchFlyout.querySelector('input');
          if (input) input.focus();
        }
      });
    }

    if (accountToggle && accountFlyout) {
      accountToggle.addEventListener('click', function () {
        var willOpen = accountFlyout.hidden;
        megaMenus.forEach(function (m) { m.hidden = true; });
        if (searchFlyout) searchFlyout.hidden = true;
        accountFlyout.hidden = !willOpen;
        updateHeaderState();
      });
    }

    /* Keyboard access for span-based nav items */
    navItems.forEach(function (item) {
      item.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          var evt = new Event('mouseenter');
          item.dispatchEvent(evt);
        }
      });
    });

    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAllMenus(); });

    if (isTransparent) {
      window.addEventListener('scroll', updateHeaderState, { passive: true });
    }
    updateHeaderState();
  }

  /* ---------- Mobile slide-in menu ---------- */
  function initMobileMenu() {
    var menu = document.querySelector('[data-mobile-menu]');
    var openBtn = document.querySelector('[data-mobile-menu-open]');
    if (!menu || !openBtn) return;
    var closeEls = menu.querySelectorAll('[data-mobile-menu-close]');

    function open() {
      menu.hidden = false;
      document.body.classList.add('mobile-menu-open');
      openBtn.setAttribute('aria-expanded', 'true');
    }
    function close() {
      menu.hidden = true;
      document.body.classList.remove('mobile-menu-open');
      openBtn.setAttribute('aria-expanded', 'false');
    }
    openBtn.addEventListener('click', open);
    closeEls.forEach(function (el) { el.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ---------- Wishlist (localStorage) ---------- */
  var WISHLIST_KEY = 'maci:wishlist';

  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || {}; }
    catch (e) { return {}; }
  }

  function setWishlist(wishlist) {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(wishlist));
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      var count = Object.keys(wishlist).length;
      el.hidden = count === 0;
      el.textContent = count;
    });
  }

  function initWishlist() {
    setWishlist(getWishlist());
    document.body.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-wishlist-toggle]');
      if (!btn) return;
      e.preventDefault();
      var id = btn.getAttribute('data-wishlist-toggle');
      var wishlist = getWishlist();
      if (wishlist[id]) delete wishlist[id]; else wishlist[id] = true;
      setWishlist(wishlist);
      document.querySelectorAll('[data-wishlist-toggle="' + id + '"]').forEach(function (el) {
        el.classList.toggle('is-active', !!wishlist[id]);
      });
    });
    var wishlist = getWishlist();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (el) {
      var id = el.getAttribute('data-wishlist-toggle');
      el.classList.toggle('is-active', !!wishlist[id]);
    });
  }

  /* ---------- Cart count badge ---------- */
  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.hidden = count === 0;
      el.textContent = count;
    });
  }

  /* ---------- Quick add (product cards) ---------- */
  function initQuickAdd() {
    document.body.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-quick-add]');
      if (!btn) return;
      e.preventDefault();
      var variantId = btn.getAttribute('data-quick-add');
      var originalLabel = btn.textContent;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      })
        .then(function (res) { return res.json(); })
        .then(function () { return fetch('/cart.js'); })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          updateCartCount(cart.item_count);
          btn.textContent = 'Added ✓';
          setTimeout(function () { btn.textContent = originalLabel; }, 1400);
        })
        .catch(function () { btn.textContent = originalLabel; });
    });
  }

  /* ---------- Newsletter ---------- */
  function initNewsletter() {
    var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    document.querySelectorAll('[data-newsletter-form]').forEach(function (form) {
      var messageEl = form.parentElement.querySelector('[data-newsletter-message]');
      form.addEventListener('submit', function (e) {
        var input = form.querySelector('input[type="email"]');
        var email = (input.value || '').trim();
        if (!EMAIL_RE.test(email)) {
          e.preventDefault();
          if (messageEl) {
            messageEl.textContent = 'Please enter a valid email address.';
            messageEl.classList.add('is-error');
            messageEl.hidden = false;
          }
          return;
        }
        e.preventDefault();
        fetch(form.action, { method: 'POST', body: new FormData(form) })
          .then(function () {
            form.hidden = true;
            if (messageEl) {
              messageEl.textContent = "Thank you — you're on the list.";
              messageEl.classList.remove('is-error');
              messageEl.hidden = false;
            }
          })
          .catch(function () {
            if (messageEl) {
              messageEl.textContent = 'Please enter a valid email address.';
              messageEl.classList.add('is-error');
              messageEl.hidden = false;
            }
          });
      });
    });
  }

  /* ---------- Product page ---------- */
  function initProductPage() {
    var root = document.querySelector('[data-product-page]');
    if (!root) return;

    /* Multi-option variant resolution (Color + Size act together, like real Shopify variants) */
    var mainImage = root.querySelector('[data-gallery-main-image]');
    var swatches = root.querySelectorAll('[data-color-swatch]');
    var galleryPhotos = root.querySelectorAll('[data-gallery-photo]');
    var colorLabel = root.querySelector('[data-selected-color-name]');
    var variantInput = root.querySelector('[data-selected-variant-id]');
    var addToBagBtn = root.querySelector('[data-add-to-bag]');
    var stockStatus = root.querySelector('[data-stock-status]');

    var optionNamesEl = root.querySelector('[data-option-names]');
    var variantDataEl = root.querySelector('[data-variant-data]');
    var optionNames = optionNamesEl ? JSON.parse(optionNamesEl.textContent) : [];
    var variants = variantDataEl ? JSON.parse(variantDataEl.textContent) : [];
    var initialOptionsEl = root.querySelector('[data-initial-options]');
    var selected = initialOptionsEl ? JSON.parse(initialOptionsEl.textContent) : {};

    function findVariant() {
      return variants.filter(function (v) {
        return optionNames.every(function (name, i) { return v.options[i] === selected[name]; });
      })[0];
    }

    function applyVariant() {
      var variant = findVariant();
      if (!variant) return;
      if (variantInput) variantInput.value = variant.id;
      if (addToBagBtn) {
        addToBagBtn.disabled = !variant.available;
        addToBagBtn.textContent = variant.available ? (addToBagBtn.getAttribute('data-label-available') || 'Add to Bag') : 'Sold Out';
      }
      if (stockStatus) {
        var label = stockStatus.querySelector('.label');
        stockStatus.classList.toggle('is-unavailable', !variant.available);
        if (label) {
          label.textContent = variant.available
            ? (stockStatus.getAttribute('data-in-stock-label') || 'In Stock')
            : (stockStatus.getAttribute('data-unavailable-label') || 'Currently unavailable');
        }
      }
      if (variant.featured_image && mainImage) mainImage.src = variant.featured_image.src || variant.featured_image;
    }

    function selectColor(index) {
      swatches.forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-color-swatch') === String(index)); });
      var activeSwatch = root.querySelector('[data-color-swatch="' + index + '"]');
      if (activeSwatch) {
        if (colorLabel) colorLabel.textContent = activeSwatch.getAttribute('data-color-name') || '';
        selected[activeSwatch.getAttribute('data-option-name')] = activeSwatch.getAttribute('data-color-name');
      }
      applyVariant();
    }

    swatches.forEach(function (s) {
      s.addEventListener('click', function () {
        selectColor(s.getAttribute('data-color-swatch'));
        if (typeof pauseGalleryAuto === 'function') pauseGalleryAuto(9000);
      });
    });

    /* Gallery photo browser — every uploaded photo, independent of color/variant.
       Auto-advances through the images; pauses on interaction, then resumes. */
    var galleryIndex = 0;
    var galleryTimer = null;
    var galleryResumeTimer = null;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var galleryEl = root.querySelector('.product-gallery');

    function showPhoto(i) {
      if (!galleryPhotos.length) return;
      galleryIndex = (i + galleryPhotos.length) % galleryPhotos.length;
      var photo = galleryPhotos[galleryIndex];
      galleryPhotos.forEach(function (p) { p.classList.remove('is-active'); });
      photo.classList.add('is-active');
      var src = photo.getAttribute('data-full-src') || photo.querySelector('img').src;
      if (mainImage && mainImage.src !== src) {
        mainImage.style.opacity = '0';
        var done = function () {
          mainImage.src = src;
          mainImage.style.opacity = '1';
          mainImage.removeEventListener('transitionend', done);
        };
        mainImage.addEventListener('transitionend', done);
        setTimeout(done, 260);
      }
      var activeThumb = photo;
      if (activeThumb && activeThumb.scrollIntoView) {
        activeThumb.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }
    }

    function startGalleryAuto() {
      if (reduceMotion || galleryPhotos.length < 2 || galleryTimer) return;
      galleryTimer = setInterval(function () { showPhoto(galleryIndex + 1); }, 3500);
    }
    function stopGalleryAuto() {
      if (galleryTimer) { clearInterval(galleryTimer); galleryTimer = null; }
    }
    function pauseGalleryAuto(resumeDelay) {
      stopGalleryAuto();
      if (galleryResumeTimer) clearTimeout(galleryResumeTimer);
      if (resumeDelay) galleryResumeTimer = setTimeout(startGalleryAuto, resumeDelay);
    }

    galleryPhotos.forEach(function (photo, i) {
      photo.addEventListener('click', function () {
        showPhoto(i);
        pauseGalleryAuto(9000);
      });
    });

    if (galleryEl) {
      galleryEl.addEventListener('mouseenter', function () { pauseGalleryAuto(0); });
      galleryEl.addEventListener('mouseleave', startGalleryAuto);
    }
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stopGalleryAuto(); else startGalleryAuto();
    });

    /* Hover-to-magnify the main image (fine-pointer devices only) */
    var galleryMain = root.querySelector('.product-gallery__main');
    var finePointer = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (galleryMain && mainImage && finePointer) {
      var ZOOM = 2.3;
      galleryMain.classList.add('is-zoomable');
      galleryMain.addEventListener('mouseenter', function () {
        mainImage.style.transform = 'scale(' + ZOOM + ')';
      });
      galleryMain.addEventListener('mousemove', function (e) {
        galleryMain.classList.add('is-zooming');
        var r = galleryMain.getBoundingClientRect();
        var x = Math.max(0, Math.min(100, ((e.clientX - r.left) / r.width) * 100));
        var y = Math.max(0, Math.min(100, ((e.clientY - r.top) / r.height) * 100));
        mainImage.style.transformOrigin = x + '% ' + y + '%';
      });
      galleryMain.addEventListener('mouseleave', function () {
        galleryMain.classList.remove('is-zooming');
        mainImage.style.transform = '';
        mainImage.style.transformOrigin = 'center center';
      });
    }

    startGalleryAuto();

    /* Rx / Non-Rx toggle */
    var rxFields = root.querySelector('[data-rx-fields]');
    var rxButtons = root.querySelectorAll('[data-rx-mode]');
    var rxHiddenInput = root.querySelector('[data-rx-mode-input]');
    rxButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var mode = btn.getAttribute('data-rx-mode');
        rxButtons.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
        if (rxFields) rxFields.hidden = mode !== 'rx';
        if (rxHiddenInput) rxHiddenInput.value = mode;
      });
    });

    /* Add Power visibility based on lens type */
    var lensTypeSelect = root.querySelector('[data-lens-type]');
    var addPowerField = root.querySelector('[data-add-power-field]');
    function syncAddPower() {
      if (!lensTypeSelect || !addPowerField) return;
      var needsAddPower = lensTypeSelect.value === 'Bifocal' || lensTypeSelect.value === 'Progressive';
      addPowerField.hidden = !needsAddPower;
    }
    if (lensTypeSelect) {
      lensTypeSelect.addEventListener('change', syncAddPower);
      syncAddPower();
    }

    /* Quantity stepper */
    var qtyInput = root.querySelector('[data-qty-input]');
    var qtyDec = root.querySelector('[data-qty-dec]');
    var qtyInc = root.querySelector('[data-qty-inc]');
    if (qtyInput && qtyDec && qtyInc) {
      qtyDec.addEventListener('click', function () {
        qtyInput.value = Math.max(1, parseInt(qtyInput.value || '1', 10) - 1);
      });
      qtyInc.addEventListener('click', function () {
        qtyInput.value = parseInt(qtyInput.value || '1', 10) + 1;
      });
    }

    /* Care accordion */
    root.querySelectorAll('[data-accordion-head]').forEach(function (head) {
      var panel = head.nextElementSibling;
      var glyph = head.querySelector('[data-accordion-glyph]');
      head.addEventListener('click', function () {
        var isOpen = !panel.hidden;
        panel.hidden = isOpen;
        if (glyph) glyph.textContent = isOpen ? '+' : '−';
      });
    });

    /* Wishlist button on product page (single item, shares localStorage store) */
    var wishlistBtn = root.querySelector('[data-wishlist-toggle]');
    if (wishlistBtn) {
      var wl = getWishlist();
      wishlistBtn.classList.toggle('is-active', !!wl[wishlistBtn.getAttribute('data-wishlist-toggle')]);
    }

    /* Add to bag (AJAX) */
    var form = root.querySelector('[data-product-form]');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var submitBtn = form.querySelector('[data-add-to-bag]');
        var originalLabel = submitBtn.textContent;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(Object.fromEntries(new FormData(form))),
        })
          .then(function (res) { return res.json(); })
          .then(function (data) {
            if (data.status) throw new Error(data.description || 'Unable to add to bag');
            return fetch('/cart.js');
          })
          .then(function (res) { return res.json(); })
          .then(function (cart) {
            updateCartCount(cart.item_count);
            submitBtn.textContent = 'Added to Bag ✓';
            setTimeout(function () { submitBtn.textContent = originalLabel; }, 1600);
          })
          .catch(function (err) {
            submitBtn.textContent = err.message || 'Unable to add to bag';
            setTimeout(function () { submitBtn.textContent = originalLabel; }, 2000);
          });
      });
    }
  }

  /* ---------- Product recommendations (native Shopify recommendations API) ---------- */
  function initProductRecommendations() {
    var container = document.querySelector('[data-recommendations]');
    if (!container) return;
    var url = container.getAttribute('data-url');
    fetch(url)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var replacement = parsed.querySelector('[data-recommendations]');
        if (replacement && replacement.innerHTML.trim()) container.innerHTML = replacement.innerHTML;
        else container.remove();
      })
      .catch(function () {});
  }

  /* ---------- Collection filters: auto-submit, two-sided price, drawer ---------- */
  function initCollectionFilters() {
    var form = document.querySelector('[data-filters-form]');
    if (!form) return;

    function submit() { form.requestSubmit ? form.requestSubmit() : form.submit(); }

    form.querySelectorAll('input[type="checkbox"], select').forEach(function (input) {
      input.addEventListener('change', submit);
    });

    /* Two-sided price slider */
    var minSlider = form.querySelector('[data-price-min]');
    var maxSlider = form.querySelector('[data-price-max]');
    var minLabel = form.querySelector('[data-price-min-label]');
    var maxLabel = form.querySelector('[data-price-max-label]');
    if (minSlider && maxSlider) {
      var fmt = function (v) { return '₹' + Number(v).toLocaleString('en-IN'); };
      var sync = function () {
        var lo = Math.min(+minSlider.value, +maxSlider.value);
        var hi = Math.max(+minSlider.value, +maxSlider.value);
        if (minLabel) minLabel.textContent = fmt(lo);
        if (maxLabel) maxLabel.textContent = fmt(hi);
      };
      [minSlider, maxSlider].forEach(function (s) {
        s.addEventListener('input', sync);
        s.addEventListener('change', function () {
          if (+minSlider.value > +maxSlider.value) {
            var t = minSlider.value; minSlider.value = maxSlider.value; maxSlider.value = t;
          }
          submit();
        });
      });
      sync();
    }

    /* Filter drawer (mobile / optional desktop) */
    var drawer = form.querySelector('[data-filter-drawer]');
    var overlay = document.querySelector('[data-filter-drawer-overlay]');
    var openBtn = form.querySelector('[data-filter-drawer-open]');
    function openDrawer() {
      if (drawer) drawer.classList.add('is-open');
      if (overlay) overlay.hidden = false;
      document.body.classList.add('mobile-menu-open');
    }
    function closeDrawer() {
      if (drawer) drawer.classList.remove('is-open');
      if (overlay) overlay.hidden = true;
      document.body.classList.remove('mobile-menu-open');
    }
    if (openBtn) openBtn.addEventListener('click', openDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);
    form.querySelectorAll('[data-filter-drawer-close]').forEach(function (el) {
      el.addEventListener('click', closeDrawer);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAnnouncementBar();
    initHeader();
    initMobileMenu();
    initWishlist();
    initQuickAdd();
    initNewsletter();
    initProductPage();
    initProductRecommendations();
    initCollectionFilters();

    fetch('/cart.js').then(function (res) { return res.json(); }).then(function (cart) {
      updateCartCount(cart.item_count);
    }).catch(function () {});
  });
})();
